import { downloadPdfBlob, formatCurrency } from "@gymflow/helpers";
import { InvoiceNewDTO } from "@gymflow/types";
import { AuthenticationContext } from "apps/portal/src/providers/authentication/AuthenticationContext";
import { apiV2, queryClient } from "libs/api/src/lib/apiV2";
import { DateTime } from "luxon";
import { useContext } from "react";

import { useClubSettings } from "../../../../providers";
import { Button, DownloadIcon } from "../../../atoms";
import { HostedPagesCard } from "../../components/HostedPagesCard";
import { InvoiceBadge } from "./InvoiceBadge";

export type HostedPagesReceiptCardProps = {
  invoice: InvoiceNewDTO;
};

export const HostedPagesReceiptCard = ({
  invoice,
}: HostedPagesReceiptCardProps) => {
  const { club } = useClubSettings();
  const { userId } = useContext(AuthenticationContext);

  return (
    <HostedPagesCard.Container className="p-2">
      <HostedPagesCard.Header>
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-1 flex-row flex-wrap items-center justify-between gap-y-0.5">
            <div className="flex flex-row flex-wrap items-center gap-x-1.5 gap-y-0.5">
              <div className="dark:text-gray-25 text-base font-bold text-gray-950">
                {formatCurrency(invoice.totalAmount, club.defaultCurrency)}
              </div>
              <InvoiceBadge invoice={invoice} size="xs" />
            </div>
            <div className="flex flex-row items-center gap-1.5">
              <div className="text-xs font-medium text-gray-500 dark:text-gray-400">
                {DateTime.fromISO(invoice.issueDate).toLocaleString(
                  DateTime.DATE_MED,
                )}
              </div>
              <Button
                className="p-0 pt-0.5"
                onClick={async () => {
                  const invoiceNumber = invoice.number;
                  const data = await queryClient.fetchQuery(
                    apiV2.member.member.queries.invoiceFile(
                      userId,
                      invoiceNumber,
                    ),
                  );

                  downloadPdfBlob(data, `Gymflow-${invoiceNumber}.pdf`);
                }}
                intent="transparent"
                size="icon"
              >
                <DownloadIcon
                  className="size-4"
                  pathClassName="stroke-gray-500 dark:stroke-gray-400"
                />
              </Button>
            </div>
          </div>
        </div>
      </HostedPagesCard.Header>
    </HostedPagesCard.Container>
  );
};
